import {
    FormatListBulletedRounded,
    FormatListNumberedRounded,
} from '@mui/icons-material';
import BlockButton from './BlockButton';
import { useTranslation } from 'react-i18next';

function ListButtons() {
    const { t } = useTranslation();

    return (
        <div dir="ltr">
            <BlockButton
                path="type"
                value="bulleted-list"
                icon={<FormatListBulletedRounded fontSize="small" />}
                tooltip={t('Bulleted List')}
            />
            <BlockButton
                path="type"
                value="numbered-list"
                icon={<FormatListNumberedRounded fontSize="small" />}
                tooltip={t('Numbered List')}
            />
        </div>
    );
}

export default ListButtons;
